import React from 'react';

import _ from 'lodash';

import {
  PAGE, BASIC_TEXT, TEXT, BUTTON, IMAGE, VIDEO, SHAPE, LINE, RECTANGLE,
  FORM, FORM_STEP, FORM_FIELD, FORM_SUBMIT,
  IFRAME, HTML, ANCHOR,
  CONTENT, CONTENT_FILTER_CONTAINER, CONTENT_FILTER, CONTENT_LOADING, CONTENT_PAGINATION_BUTTON, CONTENT_EMPTY_MESSAGE,
  SECTION, SECTION_COLUMN, CONTAINER, CONTENT_CARD, CONTENT_CARD_TEMPLATE,
  MENU, MENU_CONTAINER, CAROUSEL, CAROUSEL_CARD,
  LIVE_ELEMENT, LIVE_ELEMENT_CONTAINER, GROUP, MODAL, EXTERNAL_FORM, HOTSPOT, ASSET, CONTENT_SEARCH, SEEK, 
  FORM_DROPDOWN_LIST, FORM_CHECK_BOX, FORM_CHECK_LIST, FORM_TEXTAREA, FORM_NUMBER,
  OTP_FORM_SUBMIT, OTP_RESEND, OTP_INPUT, SLIDE,
  MENU_DRAGGABLE_CONTAINER,
  CHARTS,
  PROMPT_WIDGET,
  AI_IMAGE_WIDGET
} from 'constants/widgetTypes';

import { PageWidget } from './page';
import { BasicTextWidget } from './basicText';
import { TextWidget } from './text';
import { AnchorWidget } from './anchor';
import { ButtonWidget } from './button';
import { FormWidget } from './form';
import { FormStepWidget } from './form/steps.jsx';
import { FormTextWidget } from './form/fields/textField';
import { FormOtpInputWidget } from './form/fields/otpInput';
import { SubmitButtonWidget } from './form/submit';
import { OtpSubmitButtonWidget } from './form/otpSubmit';
import { OtpResendButtonWidget } from './form/otpResend';
import { IFrameWidget } from "./iframe";
import { HtmlWidget } from "./html";
import { ImageWidget } from './image';
import { VideoWidget } from './video';
import { ShapeWidget } from './shape';
import { RectangleWidget } from './rectangle';
import { LineWidget } from './line';
import { ContentWidget } from './content';
import { FilterWidget } from './content/filters';
import { FilterContainerWidget } from './content/filters/filterContainer';
import { LoadingWidget } from './content/loading';
import { ContentCardWidget } from './content/card';
import { ContentCardTemplateWidget } from './content/card/template';
import { EmptyMessageWidget } from './content/emptyMessage';
import { PaginationButtonWidget } from './content/paginationButton';
import { LiveElementsWidget } from './liveElements';
import { LiveElementContainerWidget } from './liveElements/container';
import { SectionWidget } from './section';
import { SectionColumnWidget } from './section/column';
import { ContainerWidget } from './container';
import { MenuWidget } from './menu';
import { MenuContainerWidget } from './menu/menuContainer';
import { GroupWidget } from './group';
import { ModalWidget } from './modal';
import { ExternalFormWidget } from './externalForm';
import { HotspotWidget } from './hotspot'; 
import { CarouselWidget } from './carousel';
import { CarouselCardWidget } from './carousel/card';
import { AssetWidget } from './asset';
import { SearchWidget } from './content/filters/search';
import { SeekWidget } from './seek';
import { SlideWidget } from './slide';
import { FormDropDownWidget } from './form/fields/dropdownList';
import { FormCheckBoxWidget } from './form/fields/checkbox';
import { FormTextAreaWidget } from './form/fields/textArea';
import { CheckBoxListWidget } from './form/fields/checkBoxList';
import { NumberFieldWidget } from './form/fields/numberField';
import { MenuDraggableContainerWidget } from './menu/menuDraggableContainer';
import { PromptWidget } from './prompt';
import { AiImageWidget } from './aiImage';
import { ChartWidget } from './charts';


export class WidgetRegistry {
  static register(type, component) {
    WidgetRegistry.widgets[type] = {
      ...component
    };
  }

  static sizeConfig(widget, mediaCache) {
    if (!widget) {
      return null;
    }

    var type = typeof widget === 'string' ? widget : widget.type;
    var config = WidgetRegistry.widgets[type];
    if (!config) {
      console.error(`Widget config for type ${type} not found. Check if the widget type is registered`);
      return false;
    }
    return config.sizeConfig?.(widget, mediaCache);
  }


  static moveableConfig(editorSession, widget, breakpoint) {
    if (!widget) {
      return null;
    }

    var type = typeof widget === 'string' ? widget : widget.type;
    var config = WidgetRegistry.widgets[type];
    if (!config) {
      console.error(`Widget config for type ${type} not found. Check if the widget type is registered`);
      return false;
    }

    return config.moveableConfig(editorSession, widget, breakpoint);
  }

  static render(type, props, editable) {
    var config = WidgetRegistry.widgets[type];
    if (!config) {
      console.error(`Widget config for type ${type} not found. Check if the widget type is registered`);
      return false;
    }

    var Component = config['editor'];
    if (!Component) {
      return false;
    }

    const key = props.id;
    //return React.createElement(Component, {...props, key, editable});
  }

  static properties(type, props, editable) {
    var Component = WidgetRegistry.widgets[type].properties;

    if (!Component) {
      return false;
    }
    const key = props.uid;
    return React.createElement(Component, { ...props, key, editable });
  }


  static actions(editorSession, type, breakpoint, props) {
    var actionsFn = WidgetRegistry.widgets[type].actions;

    if (!actionsFn) {
      return false;
    }

    return actionsFn(editorSession, breakpoint, props);
  }

  static processRequest(widgets) {
    if (!widgets) {
      return widgets;
    }

    return widgets
      .filter(widget => widget.template == null)
      .map(widget => {
        return this._processRequest(widget);
      }).filter(widget => widget != null);
  }

  static _processRequest(widget) {
    if (widget == null) {
      return null;
    }

    var updatedWidget = _.cloneDeep(widget);
    updatedWidget = _.omit(updatedWidget, 'editorState');

    const type = widget.type;
    const widgetConfig = WidgetRegistry.widgets[type];
    if (!widgetConfig) {
      return null;
    }

    var processRequestFn = widgetConfig.processRequest;

    if (processRequestFn) {
      updatedWidget = processRequestFn(updatedWidget);

      if (updatedWidget == null) {
        return null;
      }
    }
    
    //Process request for page action
    var actions = updatedWidget.actions;
    var action = (actions && actions.length > 0) ? actions[0] : null;

    if(action && action.type === 'page') {
      action = _.omit(action, 'page');
      if(typeof action.value === 'object' && action.value.id) {
        action.value = action.value.id;
      }

      actions = [action];
      updatedWidget = { ...updatedWidget, actions };
    }

    if(action && action.type === 'slide') {
      action = {
        ...action,
        value: {
          page: _.get(action, 'value.page', '') || '',
          slide: _.get(action, 'value.slide', '') || ''
        }
      }

      actions = [action];
      updatedWidget = { ...updatedWidget, actions };
    }

    if(action && action.type === 'carousel') {
      action = {
        ...action,
        value: {
          carouselUid: _.get(action, 'value.carouselUid', '') || '',
          carouselName: _.get(action, 'value.carouselName', '') || '',
          slideUid: _.get(action, 'value.slideUid', '') || '',
          name: _.get(action, 'value.name', '') || '',
        }
      }

      actions = [action];
      updatedWidget = { ...updatedWidget, actions };
    }


    return {
      ...updatedWidget,
      widgets: this.processRequest(updatedWidget.widgets)
    };
  }
}

WidgetRegistry.widgets = {};

//Initial widgets
WidgetRegistry.register(PAGE, {
  editor: PageWidget,
  moveableConfig: PageWidget.moveableConfig,
  sizeConfig: PageWidget.sizeConfig,
  processRequest: PageWidget.processRequest,
  actions: PageWidget.actions,
  processRequest: PageWidget.processRequest
});

WidgetRegistry.register(SLIDE, {
  editor: SlideWidget,
  moveableConfig: SlideWidget.moveableConfig,
  processRequest: SlideWidget.processRequest,
  actions: SlideWidget.actions,
  processRequest: SlideWidget.processRequest
});

WidgetRegistry.register(BASIC_TEXT, {
  editor: BasicTextWidget,
  moveableConfig: BasicTextWidget.moveableConfig,
  sizeConfig: BasicTextWidget.sizeConfig,
  actions: BasicTextWidget.actions,
  processRequest: BasicTextWidget.processRequest
});

WidgetRegistry.register(TEXT, {
  editor: TextWidget,
  moveableConfig: TextWidget.moveableConfig,
  sizeConfig: TextWidget.sizeConfig,
  actions: TextWidget.actions,
  processRequest: TextWidget.processRequest
});

WidgetRegistry.register(BUTTON, {
  editor: ButtonWidget,
  moveableConfig: ButtonWidget.moveableConfig,
  sizeConfig: ButtonWidget.sizeConfig,
  actions: ButtonWidget.actions,
  processRequest: ButtonWidget.processRequest
});

WidgetRegistry.register(FORM, {
  editor: FormWidget,
  moveableConfig: FormWidget.moveableConfig,
  actions: FormWidget.actions,
  processRequest: FormWidget.processRequest
});

WidgetRegistry.register(FORM_STEP, {
  editor: FormStepWidget,
  moveableConfig: FormStepWidget.moveableConfig,
  actions: FormStepWidget.actions,
  processRequest: FormStepWidget.processRequest
});

WidgetRegistry.register(FORM_FIELD, {
  editor: FormTextWidget,
  moveableConfig: FormTextWidget.moveableConfig,
  actions: FormTextWidget.actions,
  processRequest: FormTextWidget.processRequest
});

WidgetRegistry.register(OTP_INPUT, {
  editor: FormOtpInputWidget,
  moveableConfig: FormOtpInputWidget.moveableConfig,
  actions: FormOtpInputWidget.actions,
  processRequest: FormOtpInputWidget.processRequest
});

WidgetRegistry.register(FORM_NUMBER, {
  editor: NumberFieldWidget,
  moveableConfig: NumberFieldWidget.moveableConfig,
  actions: NumberFieldWidget.actions,
  processRequest: NumberFieldWidget.processRequest
});

WidgetRegistry.register(FORM_TEXTAREA, {
  editor: FormTextAreaWidget,
  moveableConfig: FormTextAreaWidget.moveableConfig,
  actions: FormTextAreaWidget.actions,
  processRequest: FormTextAreaWidget.processRequest
});

WidgetRegistry.register(FORM_DROPDOWN_LIST, {
  editor: FormDropDownWidget,
  moveableConfig: FormDropDownWidget.moveableConfig,
  actions: FormDropDownWidget.actions,
  processRequest: FormDropDownWidget.processRequest
})

WidgetRegistry.register(FORM_CHECK_BOX, {
  editor: FormCheckBoxWidget,
  moveableConfig: FormCheckBoxWidget.moveableConfig,
  actions: FormCheckBoxWidget.actions,
  processRequest: FormCheckBoxWidget.processRequest
})

WidgetRegistry.register(FORM_CHECK_LIST, {
  editor: CheckBoxListWidget,
  moveableConfig: CheckBoxListWidget.moveableConfig,
  actions: CheckBoxListWidget.actions,
  processRequest: CheckBoxListWidget.processRequest
})

WidgetRegistry.register(FORM_SUBMIT, {
  editor: ButtonWidget,
  moveableConfig: SubmitButtonWidget.moveableConfig,
  actions: SubmitButtonWidget.actions,
  processRequest: SubmitButtonWidget.processRequest
});

WidgetRegistry.register(OTP_FORM_SUBMIT, {
  editor: ButtonWidget,
  moveableConfig: OtpSubmitButtonWidget.moveableConfig,
  actions: OtpSubmitButtonWidget.actions,
  processRequest: OtpSubmitButtonWidget.processRequest
});

WidgetRegistry.register(OTP_RESEND, {
  editor: ButtonWidget,
  moveableConfig: OtpResendButtonWidget.moveableConfig,
  actions: OtpResendButtonWidget.actions,
  processRequest: OtpResendButtonWidget.processRequest
});


WidgetRegistry.register(IFRAME, {
  editor: IFrameWidget,
  moveableConfig: IFrameWidget.moveableConfig,
  actions: IFrameWidget.actions,
  processRequest: IFrameWidget.processRequest
});

WidgetRegistry.register(CHARTS, {
  editor: ChartWidget,
  moveableConfig: ChartWidget.moveableConfig,
  actions: ChartWidget.actions,
  processRequest: ChartWidget.processRequest
});

WidgetRegistry.register(HTML, {
  editor: HtmlWidget,
  moveableConfig: HtmlWidget.moveableConfig,
  actions: HtmlWidget.actions,
  processRequest: HtmlWidget.processRequest
});

WidgetRegistry.register(ANCHOR, {
  editor: AnchorWidget,
  moveableConfig: AnchorWidget.moveableConfig,
  actions: AnchorWidget.actions,
  processRequest: AnchorWidget.processRequest
});

WidgetRegistry.register(HTML, {
  editor: HtmlWidget,
  moveableConfig: HtmlWidget.moveableConfig,
  actions: HtmlWidget.actions,
  processRequest: HtmlWidget.processRequest
});

WidgetRegistry.register(EXTERNAL_FORM, {
  editor: ExternalFormWidget,
  moveableConfig: ExternalFormWidget.moveableConfig,
  actions: ExternalFormWidget.actions,
  processRequest: ExternalFormWidget.processRequest
})

WidgetRegistry.register(SHAPE, {
  editor: ShapeWidget,
  moveableConfig: ShapeWidget.moveableConfig,
  actions: ShapeWidget.actions,
  processRequest: ShapeWidget.processRequest
});

WidgetRegistry.register(RECTANGLE, {
  editor: RectangleWidget,
  moveableConfig: RectangleWidget.moveableConfig,
  actions: RectangleWidget.actions,
  processRequest: RectangleWidget.processRequest
});

WidgetRegistry.register(LINE, {
  editor: LineWidget,
  moveableConfig: LineWidget.moveableConfig,
  actions: LineWidget.actions
});

WidgetRegistry.register(IMAGE, {
  editor: ImageWidget,
  moveableConfig: ImageWidget.moveableConfig,
  sizeConfig: ImageWidget.sizeConfig,
  actions: ImageWidget.actions,
  processRequest: ImageWidget.processRequest
});

WidgetRegistry.register(VIDEO, {
  editor: VideoWidget,
  moveableConfig: VideoWidget.moveableConfig,
  sizeConfig: VideoWidget.sizeConfig,
  actions: VideoWidget.actions,
  processRequest: VideoWidget.processRequest
});

WidgetRegistry.register(CONTENT, {
  editor: ContentWidget,
  moveableConfig: ContentWidget.moveableConfig,
  sizeConfig: ContentWidget.sizeConfig,
  actions: ContentWidget.actions,
  processRequest: ContentWidget.processRequest
});

WidgetRegistry.register(CONTENT_FILTER, {
  editor: FilterWidget,
  moveableConfig: FilterWidget.moveableConfig,
  sizeConfig: FilterWidget.sizeConfig,
  actions: FilterWidget.actions,
  processRequest: FilterWidget.processRequest
})

WidgetRegistry.register(CONTENT_FILTER_CONTAINER, {
  editor: FilterContainerWidget,
  moveableConfig: FilterContainerWidget.moveableConfig,
  sizeConfig: FilterContainerWidget.sizeConfig,
  actions: FilterContainerWidget.actions,
  processRequest: FilterContainerWidget.processRequest
});

WidgetRegistry.register(CONTENT_SEARCH, {
  editor: SearchWidget,
  moveableConfig: SearchWidget.moveableConfig,
  sizeConfig: SearchWidget.sizeConfig,
  actions: SearchWidget.actions,
  processRequest: SearchWidget.processRequest
})

WidgetRegistry.register(CONTENT_LOADING, {
  editor: LoadingWidget,
  moveableConfig: LoadingWidget.moveableConfig,
  sizeConfig: LoadingWidget.sizeConfig,
  actions: LoadingWidget.actions,
  processRequest: LoadingWidget.processRequest
})

WidgetRegistry.register(CONTENT_PAGINATION_BUTTON, {
  editor: ButtonWidget,
  moveableConfig: PaginationButtonWidget.moveableConfig,
  sizeConfig: PaginationButtonWidget.sizeConfig,
  actions: PaginationButtonWidget.actions,
  processRequest: PaginationButtonWidget.processRequest
});

WidgetRegistry.register(CONTENT_EMPTY_MESSAGE, {
  editor: EmptyMessageWidget,
  moveableConfig: EmptyMessageWidget.moveableConfig,
  sizeConfig: EmptyMessageWidget.sizeConfig,
  actions: EmptyMessageWidget.actions,
  processRequest: EmptyMessageWidget.processRequest
});

WidgetRegistry.register(CONTENT_CARD, {
  editor: ContentCardWidget,
  moveableConfig: ContentCardWidget.moveableConfig,
  actions: ContentCardWidget.actions,
  processRequest: ContentCardWidget.processRequest
});

WidgetRegistry.register(CONTENT_CARD_TEMPLATE, {
  editor: ContentCardTemplateWidget,
  moveableConfig: ContentCardTemplateWidget.moveableConfig,
  actions: ContentCardTemplateWidget.actions,
  processRequest: ContentCardTemplateWidget.processRequest
});

WidgetRegistry.register(LIVE_ELEMENT, {
  editor: LiveElementsWidget,
  moveableConfig: LiveElementsWidget.moveableConfig,
  actions: LiveElementsWidget.actions,
  processRequest: LiveElementsWidget.processRequest
})

WidgetRegistry.register(LIVE_ELEMENT_CONTAINER, {
  editor: LiveElementContainerWidget,
  moveableConfig: LiveElementContainerWidget.moveableConfig,
  actions: LiveElementContainerWidget.actions,
  processRequest: LiveElementContainerWidget.processRequest
})

WidgetRegistry.register(LIVE_ELEMENT, {
  editor: LiveElementsWidget,
  moveableConfig: LiveElementsWidget.moveableConfig,
  actions: LiveElementsWidget.actions,
  processRequest: LiveElementsWidget.processRequest
})

WidgetRegistry.register(LIVE_ELEMENT_CONTAINER, {
  editor: LiveElementContainerWidget,
  moveableConfig: LiveElementContainerWidget.moveableConfig,
  actions: LiveElementContainerWidget.actions,
  processRequest: LiveElementContainerWidget.processRequest
})

WidgetRegistry.register(SECTION, {
  editor: SectionWidget,
  moveableConfig: SectionWidget.moveableConfig,
  sizeConfig: SectionWidget.sizeConfig,
  actions: SectionWidget.actions,
  processRequest: SectionWidget.processRequest
})

WidgetRegistry.register(SECTION_COLUMN, {
  editor: SectionColumnWidget,
  moveableConfig: SectionColumnWidget.moveableConfig,
  sizeConfig: SectionColumnWidget.sizeConfig,
  actions: SectionColumnWidget.actions,
  processRequest: SectionColumnWidget.processRequest
});

WidgetRegistry.register(CONTAINER, {
  editor: ContainerWidget,
  moveableConfig: ContainerWidget.moveableConfig,
  sizeConfig: ContainerWidget.sizeConfig,
  actions: ContainerWidget.actions,
  processRequest: ContainerWidget.processRequest
})

WidgetRegistry.register(MENU, {
  editor: MenuWidget,
  moveableConfig: MenuWidget.moveableConfig,
  sizeConfig: MenuWidget.sizeConfig,
  actions: MenuWidget.actions,
  processRequest: MenuWidget.processRequest
})

WidgetRegistry.register(MENU_CONTAINER, {
  editor: MenuContainerWidget,
  moveableConfig: MenuContainerWidget.moveableConfig,
  actions: MenuContainerWidget.actions,
  processRequest: MenuContainerWidget.processRequest
});

WidgetRegistry.register(MENU_DRAGGABLE_CONTAINER, {
  editor: MenuDraggableContainerWidget,
  moveableConfig: MenuDraggableContainerWidget.moveableConfig,
  actions: MenuDraggableContainerWidget.actions,
  processRequest: MenuDraggableContainerWidget.processRequest
});

WidgetRegistry.register(CAROUSEL, {
  editor: CarouselWidget,
  moveableConfig: CarouselWidget.moveableConfig,
  actions: CarouselWidget.actions,
  processRequest: CarouselWidget.processRequest
})

WidgetRegistry.register(CAROUSEL_CARD, {
  editor: CarouselCardWidget,
  moveableConfig: CarouselCardWidget.moveableConfig,
  sizeConfig: CarouselCardWidget.sizeConfig,
  actions: CarouselCardWidget.actions,
  processRequest: CarouselCardWidget.processRequest
})

WidgetRegistry.register(GROUP, {
  editor: GroupWidget,
  moveableConfig: GroupWidget.moveableConfig,
  actions: GroupWidget.actions,
  processRequest: GroupWidget.processRequest
})

WidgetRegistry.register(MODAL, {
  editor: ModalWidget,
  moveableConfig: ModalWidget.moveableConfig,
  actions: ModalWidget.actions,
  processRequest: ModalWidget.processRequest
})

WidgetRegistry.register(HOTSPOT, {
  editor: HotspotWidget,
  moveableConfig: HotspotWidget.moveableConfig,
  sizeConfig: HotspotWidget.sizeConfig,
  actions: HotspotWidget.actions,
  processRequest: HotspotWidget.processRequest
})

WidgetRegistry.register(ASSET, {
  editor: AssetWidget,
  moveableConfig: AssetWidget.moveableConfig,
  sizeConfig: AssetWidget.sizeConfig,
  actions: AssetWidget.actions,
  processRequest: AssetWidget.processRequest
})

WidgetRegistry.register(SEEK, {
  editor: SeekWidget,
  moveableConfig: SeekWidget.moveableConfig,
  actions: SeekWidget.actions,
  processRequest: SeekWidget.processRequest
})

WidgetRegistry.register(PROMPT_WIDGET, {
  editor: PromptWidget,
  moveableConfig: PromptWidget.moveableConfig,
  actions: PromptWidget.actions,
  processRequest: PromptWidget.processRequest
})

WidgetRegistry.register(AI_IMAGE_WIDGET, {
  editor: AiImageWidget,
  moveableConfig: AiImageWidget.moveableConfig,
  actions: AiImageWidget.actions,
  processRequest: AiImageWidget.processRequest
})

export function regiserWidget(id, component) {
  WidgetRegistry.register(id, component);
}